<template src="./logo.html"></template>

<script>
export default {
};
</script>
